export default __webpack_public_path__ + "static/allProjects3-999c6a5ed73416d1170dca397089b2a8.png";